import MappingOverview from "../controllers/MappingOverview/MappingOverview";

const queries = () => [];

const mappingOverview = (path, navigation, exact, title) => ({
    path,
    navigation,
    component: MappingOverview,
    exact,
    queries,
    title: [title],
    components: [],
});

export default mappingOverview;
